import { render, staticRenderFns } from "./py.vue?vue&type=template&id=15688096&scoped=true"
import script from "./py.vue?vue&type=script&lang=js"
export * from "./py.vue?vue&type=script&lang=js"
import style0 from "./py.vue?vue&type=style&index=0&id=15688096&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15688096",
  null
  
)

export default component.exports